import React from 'react';
import PropTypes from 'prop-types';

import { reset } from '../../floating_navigation/helpers';
import withLocale from '../helpers/with_locale';

const Link = ({ className, href, children }) => (
  <a className={`left-components__link${className ? ` ${className}` : ''}`} href={withLocale(href)} onClick={reset}>
    {children}
  </a>
);

Link.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

export default Link;
